// extracted by mini-css-extract-plugin
module.exports = {"accessibility_icons_icons":"AccessibilityIcons_accessibility_icons_icons__WLoMC","icon":"AccessibilityIcons_icon__mr09m"};